const prototypeModules = require.context('.', false, /\.prototype\.js$/)

function getPrototype (prototype) {
  const string = String(prototype.match(/\.\/[a-zA-Z-_]+[a-zA-Z]\.prototype(?=\.js$)/))
  require(string + '')
}

prototypeModules.keys().forEach(getPrototype)